﻿import {Collapse} from './collapse';


// Popup Model

export interface IPopup {
    openPopup(status?:boolean): void;

    closePopup(status?:boolean): void;
}

export class PopupInit extends Collapse implements IPopup {
    isOpen: boolean = false;

    openPopup(status?:boolean): void {
        this.isOpen = true;
    };

    closePopup(status?:boolean): void {
        this.isOpen = false;
    };
}

// Popup Model